import { createFileRoute } from '@tanstack/react-router';
import ImportingPage from '@/pages/workspaces/collections/[collectionId]/importing.page';
import { RumPageRendered } from '@/services/rum/use-page-rendered';
import { LazyPage } from './-route-layouts';

function CollectionImportingRoute() {
  return (
    <LazyPage>
      <RumPageRendered>
        <ImportingPage />
      </RumPageRendered>
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/collections/$collectionId/importing')({
  component: CollectionImportingRoute,
});
